import React from "react";
import styles from "./index.module.css";

const ContainerInfo = ({ children, classExtra = "" }) => (
  <div className={`${styles.containerInfo} ${classExtra}`}>{children}</div>
);

export default ContainerInfo;
